import { faLock } from "@fortawesome/pro-regular-svg-icons/faLock";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Lock: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faLock} {...props} />;
};
